const SESSION_STORAGE_APPLICATION_ID = 'application-id';

export const setApplicationId = (applicationId: string) =>
  sessionStorage.setItem(SESSION_STORAGE_APPLICATION_ID, applicationId);

export const removeApplicationId = () =>
  sessionStorage.removeItem(SESSION_STORAGE_APPLICATION_ID);

export const getApplicationId = () =>
  sessionStorage.getItem(SESSION_STORAGE_APPLICATION_ID);
